
        var result = require("!!../../../../../node_modules/css-loader/dist/cjs.js!./ups-dialog.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    